import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken } from "./api";

const AuthContext = createContext(null);
const STORAGE_KEY = "admatik_rmax_token";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [storeToken, setStoreToken] = useState(null);
  const [activeStore, setActiveStore] = useState(null);

  const fetchMe = useCallback(async () => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) { setUser(false); return; }
    setToken(saved);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setToken(null);
      localStorage.removeItem(STORAGE_KEY);
      setUser(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.access_token);
    localStorage.setItem(STORAGE_KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setToken(null);
    localStorage.removeItem(STORAGE_KEY);
    setUser(false);
    setStoreToken(null);
    setActiveStore(null);
  };

  const verifyPin = async (pin, store) => {
    const { data } = await api.post("/auth/verify-pin", { pin, store_id: store.id });
    setStoreToken(data.store_token);
    setActiveStore(store);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, storeToken, activeStore, setActiveStore, login, logout, verifyPin, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
